import { aggregateEvents } from '@onward-delivery/core';
import { differenceInDays } from 'date-fns';

/**
 * Calculate the number of days since an order was received at the warehouse.
 * Plan page tooltip only. OMS Dwell uses getStorageDays.
 * @param {Object} order - The order object containing wh_events
 * @returns {number|null} The number of dwell days, or null if no received_date
 */
export const calculateDwellDays = (order) => {
    if (!order?.wh_events) return null;

    const warehouse = aggregateEvents(order.wh_events);
    if (!warehouse?.received_date) return null;

    return differenceInDays(new Date(), new Date(warehouse.received_date));
};
